import cx from "classnames";
import { motion, type MotionStyle } from "motion/react";

export default function Toy({
  id,
  label,
  className,
  style,
  ref,
}: {
  id: number;
  label: string;
  className?: string;
  style?: MotionStyle;
  ref?: React.Ref<HTMLDivElement>;
}) {
  return (
    <motion.div
      className={cx(
        "rounded-lg border-gray-400 border-2 px-4 md:px-8 py-2 w-fit opacity-40 text-xs md:text-base lg:text-lg 2xl:text-3xl grow-0 text-nowrap",
        className,
      )}
      style={style}
      animate={["initial"]}
      variants={{
        initial: {
          x: [3 * -(id % 2), -5 * -(id % 3)],
          y: [-7 * (id % 2), 14 * (id % 3)],
          rotate: 0,
          transition: {
            duration: 0.2 * (10 + 2 * ((id * 4) % 3)),
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          },
        },
      }}
      ref={ref}
    >
      {label}
    </motion.div>
  );
}
